import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@codes/ui-kit';
import { ENV } from '@codes/web-core';

export const TOOLTIP_STORAGE_KEY = `service-tooltip-closed_${ENV}`;

interface OrderProductButtonProps {
    onAddServiceClick: () => void;
}

export const OrderProductButton = ({ onAddServiceClick }: OrderProductButtonProps) => {
    const { t } = useTranslation();
    const [isTooltipVisible, setIsTooltipVisible] = useState(() => {
        try {
            const tooltipClosed = localStorage.getItem(TOOLTIP_STORAGE_KEY);
            return tooltipClosed !== 'true';
        } catch (error) {
            // localStorage 접근 실패시 기본값으로 툴팁 표시
            console.error('Failed to access localStorage:', error);
            return true;
        }
    });

    const closeTooltip = useCallback(() => {
        try {
            setIsTooltipVisible(false);
            localStorage.setItem(TOOLTIP_STORAGE_KEY, 'true');
        } catch (error) {
            console.error('Failed to save tooltip state:', error);
            // 최소한 state는 업데이트
            setIsTooltipVisible(false);
        }
    }, []);

    return (
        <div className="relative">
            {/* {isTooltipVisible && (
                <div className="tooltip-global-style">
                    {t('project.serviceAddSub')}
                    <button className="shrink-0" onClick={closeTooltip}>
                        <X className="w-[14px] h-[14px]" />
                    </button>
                </div>
            )} */}
            <Button variant="default" size="lg" className="w-full" onClick={onAddServiceClick}>
                {t('project.addService')}
            </Button>
        </div>
    );
};
